module.exports = __webpack_public_path__ + "static/media/logo1.2741cda6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/logo1.png
 ** module id = 211
 ** module chunks = 0
 **/